import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiUserSelectionListComponent } from './multi-user-selection-list.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { ControlDisabledDirectiveModule } from 'src/app/libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SearchFieldComponent } from './search-field/search-field.component';
import { UserProfileModule } from '../../user-profile/user-profile.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ProfilePictureModule } from 'src/app/shared-layout/Components/profile-picture/profile-picture.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MultiUserSelectionListComponent, SearchFieldComponent],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonModule,
    FormsModule,
    SortByModule,
    ControlDisabledDirectiveModule,
    LazyLoadImageModule,
    ProfilePictureModule,
    WithTooltipModule,
    TranslateModule
  ],
  exports: [MultiUserSelectionListComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class MultiUserSelectionListModule {}
